(function() {

    // Add the directive to the module
    angular.module("Sinewav3.Client.Shell")
        .directive(
            'fullscreenToggle',
            [
                'CHROME',
                FullscreenToggleFactory
            ]
        );

    // Factory Method
    function FullscreenToggleFactory(CHROME)
    {
        // Construct and return the instance
        return {
            restrict: 'E',
            templateUrl: CHROME.PREFIX + CHROME.FULLSCREEN + CHROME.POSTFIX
        };

    }
})();



